import api from '../../REST/api';
import withResolved from '../../REST/with-resolved';
import BalanceModal from './BalanceModal.container';

export default withResolved({
  query: api.getOpportunity,
  deriveQueryArgs: ({ id }) => ({ id }),
  as: 'opportunity',
  className: 'p-1 m-0',
  loadingProps: { className: 'py-0 px-2 my-0' },
})(BalanceModal);
